import * as yup from 'yup'

export const userInfoValidationSchema = {
    userID: yup
        .string()
        // .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, 'User ID or Business Email is invalid')
        // .email('User ID or Business Email is invalid.')
        .required('User ID or Business Email is required.'),
    password: yup
        .string()
        .min(1, '')
        .max(32, '')
        // .matches(/^[a-zA-Z0-9@#$&_%.]+$/, 'Password is Invalid')
        .required('Password is required')
}
